import type { ClusterRecord } from '../../../../../packages/contracts/src/search.js';
import { React, useMemo } from '../../shared/react.js';
import type { MapCoordinate } from './map-layout.js';
import { layoutClusterLabels, type ClusterLabelPosition } from './cluster-label-layout.js';

export function ClusterLabels(props: {
  readonly clusters: readonly ClusterRecord[];
  readonly activeClusterId: string | null;
  readonly width: number;
  readonly height: number;
  readonly featuredMatch: boolean;
  readonly queryNode: boolean;
  readonly resultCoordinates: readonly MapCoordinate[];
  readonly onSelect: (clusterId: string | null) => void;
}) {
  const positions: readonly ClusterLabelPosition[] = useMemo(
    () => layoutClusterLabels(props.clusters, {
      width: props.width,
      height: props.height,
      featuredMatch: props.featuredMatch,
      queryNode: props.queryNode,
      resultCoordinates: props.resultCoordinates
    }),
    [props.clusters, props.width, props.height, props.featuredMatch, props.queryNode, props.resultCoordinates]
  );
  const positionById: ReadonlyMap<string, ClusterLabelPosition> = useMemo(
    () => new Map(positions.map((position: ClusterLabelPosition) => [position.id, position])),
    [positions]
  );

  return (
    <div className="cluster-labels" aria-label="Semantic neighborhoods">
      {props.clusters.map((cluster) => {
        const position = positionById.get(cluster.id) ?? { x: cluster.center.x, y: cluster.center.y - .11 };
        return (
          <button
            type="button"
            key={cluster.id}
            className={props.activeClusterId === cluster.id ? 'is-active' : ''}
            style={{
              '--cluster-x': `${position.x * props.width}px`,
              '--cluster-y': `${position.y * props.height}px`,
              '--cluster-color': cluster.color
            } as any}
            onClick={() => props.onSelect(props.activeClusterId === cluster.id ? null : cluster.id)}
          >
            <i/>
            <span>{cluster.label}</span>
          </button>
        );
      })}
    </div>
  );
}
